export type RuleResponse = {
    approved: boolean;
    reason?: string;
};

export type RuleSummary = {
    approved: boolean;
    responses: RuleResponse[];
};

export type CheckArgs = {
    name: string;
    organisationName?: string;
};

export const generateRuleResponse = (
    approved: boolean,
    reason?: string,
): RuleResponse => {
    return {
        approved,
        ...(!approved && reason && { reason }),
    };
};

// Removes non alphanumeric from a string, retaining spaces. Returns as one string.
export const removeNonAlphanumeric = (word: string) => {
    return word
        .split("")
        .filter((letters: string) => {
            return !!letters.match(/[A-Za-z0-9\s]/);
        })
        .join("")
        .trim();
};
